import { api } from "..";
const endpoint = "/api/product-requests";

export const getProductRequestList = async (queryParams: any) => {
  return await api.get(`${endpoint}`, { params: queryParams });
};

export const getProductRequestById = async (id: number) => {
  return await api.get(`${endpoint}/${id}`);
};

export const createProductRequest = async (data: any) => {
  return await api.post(`${endpoint}`, data);
};

export const updateProductRequest = async (id: number, data: any) => {
  return await api.put(`${endpoint}/${id}`, data);
};

export const deleteProductRequest = async (id: number) => {
  return await api.delete(`${endpoint}/${id}`);
};

export const approveProductRequest = async (id: number) => {
  return await api.post(`${endpoint}/${id}/approve`);
};

export const rejectProductRequest = async (id: number) => {
  return await api.post(`${endpoint}/${id}/reject`);
};

export const getProductStock = async (productId: number, companyId: number) => {
  return await api.get(`${endpoint}/stock/${productId}/${companyId}`);
};

